import React from 'react';
import { Link } from 'react-router-dom';
import NotificationPanel from './NotificationPanel';
import MaintenanceToggle from './MaintenanceToggle';

const AdminHeader = () => {
  return (
    <div className="admin-header d-flex justify-content-between align-items-center mb-3">
      <div className="d-flex align-items-center">
        <h3 className="mb-0">Admin Dashboard</h3>
      </div>
      <div className="d-flex align-items-center">
        <NotificationPanel />
        {/* <MaintenanceToggle /> */}
        <div className="dropdown">
          <button 
            className="btn btn-sm btn-light dropdown-toggle" 
            type="button" 
            id="adminDropdown" 
            data-bs-toggle="dropdown" 
            aria-expanded="false"
          >
            <i className="fi fi-rr-user me-1"></i>
            Admin
          </button>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="adminDropdown">
            <li>
              <Link className="dropdown-item" to="/admin/settings">
                <i className="fi fi-rr-settings me-2"></i>
                Settings
              </Link>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            <li>
              <Link className="dropdown-item" to="/" onClick={() => localStorage.removeItem('aid')}>
                <i className="fi fi-rr-sign-out me-2"></i>
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <style jsx="true">{`
        .admin-header {
          padding: 12px 0;
          border-bottom: 1px solid #eee;
        }
      `}</style>
    </div>
  );
};

export default AdminHeader; 